module.exports = __webpack_public_path__ + "img/1344595694.a2cd4020.jpg";